import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as labs from 'vuetify/labs/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const vuetifyPlugin = createVuetify({
    components: {
        ...components,
        ...labs,
    },
    directives,
    theme: {
        themes: {
            light: {
                colors: {
                    primary: '#0088FF',
                    secondary: '#0073FC',
                    bg: 'F2F2F7',
                    searchBtn: '#E5E5E5',
                    headerBorder: '#87CEFA',
                    cardBorder: '#E8E8E8',
                    cardHeader: '#4682B4',
                    fieldLabel: '#315d81',
                    fieldText: '#333333',
                    fieldBg: '#f0f8ff',
                    fieldBorder: '#e6f2ff',
                    'on-surface': '#333333',
                    'on-background': '#333333',
                },
            },
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
});

export default vuetifyPlugin;
